import { useState } from "react";
import { GrupoDia } from './GrupoDia';

export const GrupoMesDescargas = ({ mes, diasObj, onEliminar }) => {
  const [abierto, setAbierto] = useState(false);
  const total = Object.values(diasObj).reduce((acc, arr) => acc + arr.length, 0);
  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden">
      <button
        onClick={() => setAbierto(a => !a)}
        className="w-full flex items-center justify-between px-4 py-3 bg-white hover:bg-gray-50 transition-all"
      >
        <div className="flex items-center gap-2">
          <span className="text-sm font-bold text-gray-700">
            📅 {mes.charAt(0).toUpperCase() + mes.slice(1)}
          </span>
          <span className="text-xs text-gray-400 bg-gray-100 px-2 py-0.5 rounded-full">{total}</span>
        </div>
        <span className="text-gray-400 text-sm">{abierto ? "▲" : "▼"}</span>
      </button>
      {abierto && (
        <div className="px-3 pb-3 pt-2 space-y-2 bg-gray-50">
          {Object.keys(diasObj)
            .sort((a, b) => {
  const parseDia = str => { const match = str.match(/(\d+)/); return match ? parseInt(match[1]) : 0; };
  return parseDia(b) - parseDia(a);
})
            .map(dia => (
              <GrupoDia key={dia} dia={dia} registros={diasObj[dia]} onEliminar={onEliminar} />
            ))}
        </div>
      )}
    </div>
  );
};
